import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import type { MapboxMap } from '@polaris-customerweb/sharedcomponents.core';
import { ConsoleLogService } from '@polaris-customerweb/sharedcomponents.shared';
import { Geofence } from '@polaris-customerweb/sharedcomponents.user-content';
import { GeofenceService } from 'src/app/services/geofence.service';
import { MapContentMapService } from 'src/app/services/map-content-map.service';
import { MapService } from 'src/app/services/map.service';

@Injectable({ providedIn: 'root' })
export class GeofenceMapService extends MapContentMapService {
    protected _layerIdsSelectable: string[] = [];

    constructor(
        private configService: ConfigService,
        consoleLogService: ConsoleLogService,
        private geofenceService: GeofenceService,
        mapService: MapService
    ) {
        super(consoleLogService, mapService);

        if (!this.configService.featureFlags.areGeofencesEnabled) {
            return;
        }

        super.setSourceId('geofences');

        // override selectable layers
        this._layerIdsSelectable = [
            'geofencesUnselectedBorder1',
            'geofencesUnselectedBorder2',
        ];
    }

    setSourceDataFromModel(mapboxMap: MapboxMap, geofences: Geofence[]): void {
        const geoJson = geofences
            ? this.geofenceService.geofencesToGeoJson(geofences)
            : undefined;
        super.setSourceData(mapboxMap, geoJson);
    }
}
